import Icon from "@lib/common/components/Icon/Icon";
import { formatElapsedSeconds } from "@lib/common/utils/formatElapsedSeconds";
import { Group, Text } from "@mantine/core";

export type CompletedResearchStep = {
  label: string;
  /** How long the step ran, rendered as "56s". */
  durationSeconds: number;
};

/** A finished progress update in the expanded status list: check mark, line, duration. */
export default function CompletedStatusItem({ step }: { step: CompletedResearchStep }) {
  return (
    <Group gap="xs" wrap="nowrap">
      <Icon name="check" color="green" size="0.8rem" variant="solid" />
      <Text size="sm" fw={500} lineClamp={1} lh={1}>
        {step.label}
      </Text>
      <Text size="sm" c="dimmed">
        {formatElapsedSeconds(step.durationSeconds)}
      </Text>
    </Group>
  );
}
